import { Component, Input, OnInit } from '@angular/core';
import { TrsEventsService } from 'src/app/services/trsevents.service';

@Component({
  selector: 'app-voilation-list',

  templateUrl: './voilation-list.component.html',
  styleUrls: ['./voilation-list.component.sass']
})
export class VoilationListComponent implements OnInit {
  @Input() violationList: any;


  constructor(private trsService: TrsEventsService) { }

  ngOnInit(): void {
  }

  selectViolation(violation: any) {
    this.violationList.forEach((violation: any) => {
      violation.isSelected = false;
    });
    violation.isSelected = true;
    this.sendEvent("SELECTED_VIOLATION", violation);
  }

  sendEvent(eventName: any, responseData: any) {
    let data = {
      "eventName": eventName,
      "data": responseData
    };
    this.trsService.evtdata.next(data);
  }

  onProfilePictureErrorEvent = ($event: Event): void => {
    let target = $event.target as HTMLImageElement;
    target.style.display = "none";
    const id: string | null = target.id;

    if (id != null && id !== "") {
      const violationId: string = id.split("_")[2];

      if (violationId != null && violationId !== "") {
        const defaultPicElement: HTMLElement = document.getElementById(`superadmin_img_default_${violationId}`) as HTMLElement;
        defaultPicElement.style.display = "";
      }
    }
  }
}